export default "__VITE_ASSET__B5kUX$T8__"